import React, { useEffect, Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Container, Form, Row, Spinner } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import logoWhite from "../../assets/images/logo/logo.png";
import { USER_TYPES } from "../../Constant";
import { COMPANY_LOGO } from "../../Constant";
import { showToast } from "../../Components/Common/Toast";
import { verifyAccountRequest, reset } from "../../redux/auth/verify_account/actions";

const VerifyAccount = () => {
  const dispatch = useDispatch();
  const { type, token } = useParams();
  const navigate = useNavigate();


  // Redux state
  const {
    isLoading,
    isAlreadyAccepted,
    is_redirect,
    message
  } = useSelector((state) => state.verifyAccountReducer);
  console.log("verifyAccountReducer", message);
  // Check if login type is valid
  const isValidLoginType = USER_TYPES.includes(type?.toUpperCase());

  useEffect(() => {
    if (!isValidLoginType) {
      navigate("/404");
      return;
    }

    if (token) {
      dispatch(verifyAccountRequest({ type: type.toUpperCase(), token }));
    }
  }, [dispatch, type, token, isValidLoginType, navigate]);

  useEffect(() => {
    if (message) {
      if (isAlreadyAccepted || message.includes("success")) {

        if (is_redirect) {
          setTimeout(() => {
            navigate(`${process.env.PUBLIC_URL}/${type}/auth/login/`);
          }, 1000);
        }
      }
      // Reset state after handling
      // dispatch(reset());
    }
  }, [message, isAlreadyAccepted, is_redirect, dispatch, navigate, type]);

  return (
    <Fragment>
      <Container fluid className="p-0 login-page">
        <Row className="m-0">
          <Col xl="12 p-0">
            <div className="login-card">
              <Form className="theme-form login-form">
                <div className="text-center mb-4">
                  <a href={`${process.env.PUBLIC_URL}/auth/login`} className="mb-4">
                    <img
                      src={COMPANY_LOGO}
                      alt="Company Logo"
                      style={{ width: "150px" }}
                    />
                  </a>
                </div>

                <h4 className="text-center mb-4">
                  {isAlreadyAccepted ? "Account Verified" : "Verifying Your Account"}
                </h4>

                {/* Loading State */}
                {isLoading && (
                  <div className="text-center">
                    <Spinner color="primary" />
                    <p>Processing verification...</p>
                  </div>
                )}

                {/* Error State */}
                {message && (
                  <div className="text-center text-danger">
                    <p>{message}</p>
                  </div>
                )}

                {/* Success State */}
                {isAlreadyAccepted && !isLoading && (
                  <div className="text-center text-success">

                    {is_redirect && <p>Redirecting to login page...</p>}
                  </div>
                )}
              </Form>
            </div>
          </Col>
        </Row>
        <ToastContainer />
      </Container>
    </Fragment>
  );
};

export default VerifyAccount;
